
const headers = [
    {
      label: 'AccessToken',
      field: 'AccessToken',
    },
    {
      label: 'RefreshToken',
      field: 'RefreshToken',      
    },
    {
      label: 'AccessTokenExpired',
      field: 'AccessTokenExpired',
    },
    {
      label: 'RefreshTokenExpired',
      field: 'RefreshTokenExpired',      
    },
    {
      label: 'Action',
      field: 'action',
      tdClass: 'text-center',
    },
  ]

  export default headers